module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Mobile 2x.4d2a8f27.webp";